import React from 'react'
import { CircularProgress } from 'material-ui'

function CommonLoader({ size, thickness, propStyle }) {
  return (
    <div style={propStyle || { textAlign: 'center' }}>
      <CircularProgress size={size || 60} thickness={thickness || 5} />
    </div>
  )
}

export default CommonLoader



/** WEBPACK FOOTER **
 ** ./src/components/CommonLoader/CommonLoader.js
 **/